<template>
	<div class="container" id="UserPanel">
		<div class="row text-center">
			<div class="col">
				<h2>Bem vindo ao Painel</h2>
				<button class="btn btn-danger w-25" @click.prevent="logout()">
					Sair
				</button>
			</div>
		</div>
		<div class="row">
			<div class="col-12">
				<br />
				<h5>Meus sites</h5>
				<br />
			</div>
			<div class="col-4">
				<button
					class="btn btn-block btn-primario"
					@click.prevent="createSite()"
				>
					Novo site Uli
				</button>
				<br />
				<br />
			</div>
			<div class="w-100"></div>
			<div
				class="col-12 col-md-4 site-list"
				v-for="(site, index) in sitesList"
				:key="site.siteId"
			>
				<div class="card text-left">
					<h5 class="card-header">{{ site.name }}</h5>
					<div class="card-body">
						<p class="card-text">
							{{ normalizeDescription(site.description) }}
						</p>
						<p>
							<small>Criado em: {{ site.created_at }}</small>
						</p>
						<a
							href="#"
							class="card-link"
							v-if="site.wizard < 6"
							@click.prevent="
								goWizard(
									site.siteId,
									site.wizard,
									site.segment,
									site.email,
									site.contact_name,
									site.name
								)
							"
							>Continuar</a
						>
						<a
							href="#"
							class="card-link"
							v-else
							@click.prevent="goDashboard(site)"
							>Painel</a
						>
						<a
							href="#"
							class="card-link float-right"
							@click.prevent="removeSite(site, index)"
							>Excluir</a
						>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import axios from "axios";
	export default {
		name: "UserPanel",
		data() {
			return {
				sitesList: [],
				ROOT_API: null,
			};
		},
		beforeCreate: function () {
			if (!this.$session.exists()) {
				this.$router.push("/login");
			}
		},
		created() {
			this.token = this.$session.get("jwt");
			this.ROOT_API = process.env.ROOT_API;
			this.loadUserSites();
			this.resetWizard();
		},
		methods: {
			createSite,
			loadUserSites,
			goWizard,
			logout,
			resetWizard,
			goDashboard,
			removeSite,
			normalizeDescription,
		},
	};
	function normalizeDescription(fullDescription) {
		let mainText = null;
		if (fullDescription) {
			if (fullDescription.length > 120) {
				mainText = fullDescription.substring(0, 120) + "...";
			} else {
				mainText = fullDescription;
			}
		}
		return mainText;
	}
	function removeSite(site, index) {
		let totalData = "";
		let token = this.$session.get("jwt");
		axios({
			method: "post",
			url: this.ROOT_API + "/api/site/" + site.siteId + "/delete",
			data: totalData,
			headers: {
				Authorization: "Bearer " + token,
				"Content-Type": "application/x-www-form-urlencoded",
			},
		})
			.then((response) => {
				this.sitesList.splice(index, 1);
			})
			.catch(function (response) {
				console.log("Erro ao gerar ID do site");
			});
	}
	function createSite() {
		let totalData = "";
		let token = this.$session.get("jwt");
		axios({
			method: "get",
			url: this.ROOT_API + "/api/site/create",
			data: totalData,
			headers: {
				Authorization: "Bearer " + token,
				"Content-Type": "application/x-www-form-urlencoded",
			},
		})
			.then((response) => {
				console.log(response);
				this.goWizard(response.data.siteId, 1, 0, null, null, null);
			})
			.catch(function (response) {
				console.log("Erro ao gerar ID do site");
			});
	}

	function loadUserSites() {
		let totalData = "";
		let token = this.$session.get("jwt");
		axios({
			method: "get",
			url: this.ROOT_API + "/api/user/get",
			data: totalData,
			headers: {
				Authorization: "Bearer " + token,
				"Content-Type": "application/x-www-form-urlencoded",
			},
		})
			.then((response) => {
				this.sitesList = response.data.sites;
				this.$session.set("userName", response.data.name);
				this.$session.set("userEmail", response.data.email);
			})
			.catch(function (response) {});
	}

	function goWizard(
		siteId,
		step,
		segmentId,
		userSiteEmail,
		userSiteName,
		fantasyName
	) {
		if (this.$session.has("siteId")) {
			this.$session.remove("siteId");
		}
		this.$session.set("siteId", siteId);
		this.$session.set("passo", step);
		this.$session.set("segmentId", segmentId);
		this.$session.set("userSiteEmail", userSiteEmail);
		this.$session.set("userSiteName", userSiteName);
		this.$session.set("fantasyName", fantasyName);
		this.$router.push("/wizard");
	}

	function logout() {
		this.$session.destroy();
		this.$router.push("/login");
	}

	function resetWizard() {
		if (this.$session.has("passo")) {
			this.$session.remove("passo");
		}
		if (this.$session.has("segmentId")) {
			this.$session.remove("segmentId");
		}
		if (this.$session.has("userSiteEmail")) {
			this.$session.remove("userSiteEmail");
		}
		if (this.$session.has("userSiteName")) {
			this.$session.remove("userSiteName");
		}
		if (this.$session.has("fantasyName")) {
			this.$session.remove("fantasyName");
		}
	}

	function goDashboard(site) {
		this.$session.set("siteId", site.siteId);
		this.$router.push("/dashboard");
	}
</script>
<style scoped>
	.site-list .card {
		margin-bottom: 20px;
	}

	.site-list .card .card-body {
		padding: 10px 24px 24px;
	}
</style>



// WEBPACK FOOTER //
// src/components/UserPanel.vue